export const FEATURE_FLAGS = {
  DSP_TENANT_ONBOARDING: 'feat-dsp-tenant-onboarding',
  SERVICE_KEYS_ENABLED: 'feat-service-keys-enabled',
} as const;

export type FeatureFlag = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];
